import {Empty, Table, Typography} from 'antd'
import {DeleteOutlined, EditOutlined} from '@ant-design/icons'
import {useIntl} from 'react-intl'
import {formatEmptyValue} from '../../../utils/common'
import RecordsCount from '../../common/RecordsCount'
import TableActions from '../../common/TableActions'
import EllipsisTooltip from '../../common/EllipsisTooltip'

const CircuitTable = ({dataSource, pagination, getCircuitListData, onEdit, onDelete}) => {
  const intl = useIntl()

  const columns = [
    {
      title: intl.formatMessage({id: 'circuits.name'}),
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
      render: (text) => (
        <EllipsisTooltip className='ellipsis'>
          <span>{formatEmptyValue(text)}</span>
        </EllipsisTooltip>
      ),
    },
    {
      title: intl.formatMessage({id: 'circuits.description'}),
      dataIndex: 'description',
      key: 'description',
      sorter: (a, b) => (a.description || '').localeCompare(b.description || ''),
      render: (text) => (
        <EllipsisTooltip className='ellipsis'>
          <span>{formatEmptyValue(text)}</span>
        </EllipsisTooltip>
      ),
    },
    {
      title: intl.formatMessage({id: 'circuits.signalName'}),
      dataIndex: ['signal_name', 'name'],
      key: 'signal_name',
      sorter: (a, b) =>
        (a.signal_name?.name || '').localeCompare(b.signal_name?.name || ''),
      render: (text) => (
        <EllipsisTooltip className='ellipsis'>
          <span>{formatEmptyValue(text)}</span>
        </EllipsisTooltip>
      ),
    },
      {
        title: intl.formatMessage({id: 'circuits.actions'}),
        key: 'actions',
        width: 136,
        align: 'right',
        render: (_, record) => (
          <TableActions
            actions={[
              { key: 'edit', label: intl.formatMessage({id: 'forms.edit'}), icon: <EditOutlined />, onClick: () => onEdit(record) },
              { key: 'delete', label: intl.formatMessage({id: 'forms.delete'}), icon: <DeleteOutlined />, danger: true, onClick: () => onDelete(record) },
            ]}
          />
        ),
      },
  ]

  return (
    <>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataSource}
        showSorterTooltip={false}
        scroll={dataSource?.length ? {x: 'max-content'} : undefined}
        pagination={{
          current: pagination?.currentPage,
          pageSize: 10,
          total: pagination?.totalCount,
          showSizeChanger: false,
          hideOnSinglePage: true,
          showTotal: (total) => <RecordsCount count={total} />,
          onChange: (page) => {
            const offset = (page - 1) * 10
            const url = pagination?.nextPageLink
              ? new URL(pagination?.nextPageLink)
              : new URL(pagination?.prevPageLink)
            url.searchParams.set('offset', offset)
            getCircuitListData(url.toString())
          },
        }}
        locale={{
          emptyText: (
            <div style={{padding: '40px'}}>
              <Empty description={<RecordsCount count={0} />} />
            </div>
          ),
        }}
      />
      {pagination && pagination?.totalPages <= 1 && pagination?.totalCount > 0 && (
        <Typography.Text>
          <RecordsCount count={pagination?.totalCount} />
        </Typography.Text>
      )}
    </>
  )
}

export default CircuitTable
